import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import Container from '@mui/material/Container';
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import Stack from '@mui/material/Stack';
import SvgIcon from "@mui/material/SvgIcon";
import Typography from '@mui/material/Typography';

import { Seo } from 'src/components/seo';
import { usePageView } from 'src/hooks/use-page-view';
import { LandingRecordTable } from 'src/sections/landing/payment-audit/alert/record-table';

const Page = () => {
  usePageView();
  return (
    <>
      <Seo title="Payment Audit : Records" />
      <Box
        component="main"
        sx={{ flexGrow: 1, py: 8 }}>
        <Container maxWidth="xxl">
          <Stack
            spacing={3}
            sx={{ mb: 4 }}
          >
            <Stack
              direction="row"
              justifyContent="space-between">
              <Typography variant="h4" >
                Records
              </Typography>
              <Button
                startIcon={
                  <SvgIcon>
                    <PlusIcon />
                  </SvgIcon>
                }
                variant="contained"
              >
                Add
              </Button>
            </Stack>
          </Stack>
          <LandingRecordTable />
        </Container>
      </Box>
    </>
  );
};

export default Page;
